import { errorAlert } from 'cadenza/alert';
import { context } from 'cadenza/map/context';
import { LayerProperty } from 'cadenza/map/layer-property';
import { MapProperty } from 'cadenza/map/map-property';
import { PhotoLayerApi } from 'cadenza/api-client/photolayer-api';

import { EditSketch } from './edit-sketch';
import { LayerAction } from './layer-action';
import i18n from './layer-actions.properties';
import { TogglePhotos, isPhotoMasterLayer } from './toggle-photos';

export class EditPhotos extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('photoLayer.editPhotos')
    }, options));
    this.#map = options.map;
  }

  execute () {
    const visibleArea = this.#map.getView().calculateVisibleExtent();
    const visibleAreaInPixels = this.#map.getInnerSize();
    const mapWidth = visibleAreaInPixels[0];
    const mapHeight = visibleAreaInPixels[1];
    context(this.#map).loading = true;
    return new PhotoLayerApi(this.#map.get(MapProperty.ID), this._layer.get(LayerProperty.ID))
      .convertToSketchLayer(visibleArea, mapWidth, mapHeight)
      .then(sketchLayerId => {
        // We wait for HidePhotos, because it implicitly synchronizes the view context.
        const togglePhotosAction = new TogglePhotos(this._layer, { map: this.#map });
        // eslint-disable-next-line promise/no-nesting,promise/no-return-wrap
        return togglePhotosAction.execute().then(() => Promise.resolve(sketchLayerId));
      }).then(sketchLayerId => {
        const sketchLayer = context(this.#map).getLayer(sketchLayerId);
        return new EditSketch(sketchLayer, { map: this.#map }).execute();
      }).catch(error => {
        if (error.message.includes('too many images')) {
          errorAlert(i18n('common:error'), i18n('photoLayer.editPhotos.tooLarge'));
        } else if (!error.message.includes('Operation aborted')) {
          errorAlert(i18n('common:error'), i18n('photoLayer.editPhotos.failed'));
        }
        throw new Error(error.message);
      }).finally(() => { context(this.#map).loading = false; });
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isEditingLayer
      && window.Disy.isSketchPaletteAvailable
      && this._layer.get(LayerProperty.HAS_ATTACHMENTS)
      && isPhotoMasterLayer(this.#map, this._layer);
  }

}
